import angular from "angular";

angular
    .module('app')
    .filter('getByLang',['Language', function (Language) {
        return function (obj, fields) {
            if (Language == 'kk') {
                return obj[fields[0]];
            }
            if (Language == 'ru') {
                return obj[fields[1]];
            }
        }
    }]);

